module.exports = __webpack_public_path__ + "static/media/test-butterfly.65990f4c.jpg";